const data = [
  { id: "HTML", content: `<div style="margin:16px 0"></div>` },
  {
    id: "partida",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/icons/SVG/lectura" alt="icono lectura" width="36" height="36">
        <div><strong>Punto de partida |</strong> Docentes que dejan huella</div>
        </div>
        <div style="margin-bottom:16px;">Trabajar con pasi&oacute;n &iquest;Has pensado en la influencia que tienes sobre tus estudiantes?</div> 
    `,
  },
  {
    id: "bienvenida",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/icons/SVG/bienvenida_v2.svg" alt="icono lectura" width="36" height="36">
        <div><strong>Te damos la bienvenida! |</strong> Planifica tu trabajo en Campus</div>
        </div>
        <div style="margin-bottom:16px;">En el planificador podr&aacute;s visualizar todo lo que tienes que hacer para completar el m&oacute;dulo y organizarte mejor.</div> 
    `,
  },
  {
    id: "ampliarMirada",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/icons/SVG/lectura" alt="icono lectura" width="36" height="36">
        <div><strong>Ampliar la mirada |</strong>  Datos que preocupan</div>
        </div>
        <div style="margin-bottom:16px;">Desigualdades de nuestra regi&oacute;n.</div> 
    `,
  },
  {
    id: "concluir",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/3c25932e-13bb-4d02-a942-032ed00b6ae0.png" alt="icono lectura" width="36" height="36">
        <div><strong>Para concluir |</strong>  Llegamos al final del m&oacute;dulo</div>
        </div>
        <div style="margin-bottom:16px;">Repasemos los contenidos.</div> 
    `,
  },
  {
    id: "ATTACH",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/icons/SVG/entrega" alt="icono lectura" width="36" height="36">
        <div><strong>Actividad para entregar |</strong> Subt&iacute;tulo</div>
        </div>
        <div style="margin-bottom:16px;">Bajada.</div>
    `,
  },
  {
    id: "FORUM",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/icons/SVG/foro" alt="icono lectura" width="36" height="36">
        <div><strong>Foro |</strong> Subt&iacute;tulo</div>
        </div>
        <div style="margin-bottom:16px;">Bajada.</div>
    `,
  },
  {
    id: "COMMENTSWALL",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/icons/SVG/tablero_v2.svg" alt="icono tablero" width="36" height="36">
        <div><strong>Espacio de intercambio |</strong> Nombre de la actividad</div>
        </div>
        <div style="margin-bottom:16px;">Mira el video, responde a las consignas y sube tus reflexiones en el tablero de la actividad.</div>
    `,
  },
  {
    id: "COMMENTSWALL-CONSIGNA",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <div><strong>Espacio de intercambio |</strong> Nombre de la actividad</div>
        </div>
        <div style="margin-bottom:16px;">Mira el video, responde a las consignas y sube tus reflexiones en el tablero de la actividad.</div>
    `,
  },
  {
    id: "material-observar",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/icons/SVG/material_para_observar_v2.svg" alt="icono material" width="36" height="36">
        <div><strong>Material para observar |</strong> Subtítulo</div>
        </div>
        <div style="margin-bottom:16px;">Bajada.</div> 
    `,
  },
  {
    id: "material-leer",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/icons/SVG/material_para_leer_v2.svg" alt="icono material" width="36" height="36">
        <div><strong>Material para leer |</strong> Subtítulo</div>
        </div>
        <div style="margin-bottom:16px;">Bajada.</div> 
    `,
  },
  {
    id: "material-interactuar",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/icons/SVG/material_para_interactuar_v2.svg" alt="icono material" width="36" height="36">
        <div><strong>Material para interactuar |</strong> Subtítulo</div>
        </div>
        <div style="margin-bottom:16px;">Bajada.</div> 
    `,
  },
  {
    id: "fin-modulo",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/icons/SVG/felicitaciones_v2.svg" alt="icono material" width="36" height="36">
        <div><strong>Felicitaciones |</strong> Has llegado al final del módulo</div>
        </div>
        <div style="margin-bottom:16px;">Bajada.</div> 
    `,
  },
  {
    id: "shortcut",
    content: ` 
        <div style="display: flex; align-items: center; gap: 12px;margin:16px 0">
        <img src="https://lmsforgestorage.blob.core.windows.net/contentresources/icons/SVG/material_para_interactuar_v2.svg" alt="icono material" width="36" height="36">
        <div><strong>Título |</strong> Subtítulo</div>
        </div>
        <div style="margin-bottom:16px;">Bajada.</div> 
    `,
  },
];
  
  export default data; 

